// eslint-disable-next-line
import React from "react";
import { RiCloseLargeFill } from "react-icons/ri";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
const DisplayImageProduct = ({ onClose, image }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-4 rounded-lg shadow-lg transition-all relative">
        <InnerImageZoom
          src={image}
          zoomSrc={image}
          alt="product_image"
          className="w-[350px] h-full object-cover"
        />

        <span
          className="absolute -top-8 -right-6 mt-4 hover:text-red-700 text-xl cursor-pointer px-4 py-2 rounded-md"
          onClick={onClose}
        >
          <RiCloseLargeFill />
        </span>
      </div>
    </div>
  );
};

export default DisplayImageProduct;
